import React from 'react';
import { useLocation } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { Intercom } from '@capacitor-community/intercom';

// Utils
import { scrollToTop } from '../utils';
import { ROUTE_PATHS } from '../components/_pages/_utils/router.utils';
import { useWindowWidth } from './useWindowSize';

const NATIVE_INTERCOM_DISABLED_PATHS = ['/'];
const NATIVE_INTERCOM_DISABLED_PARTIAL_PATHS = [
  ROUTE_PATHS.LOAN_APPLICATION,
  ROUTE_PATHS.CREDIT_BUILDER,
  ROUTE_PATHS.SHORT_TERM_LOAN,
];
const WEB_INTERCOM_DISABLED_PATHS = [];
const WEB_INTERCOM_DISABLED_PARTIAL_PATHS = [
  ROUTE_PATHS.LOAN_APPLICATION,
  ROUTE_PATHS.CREDIT_BUILDER,
  ROUTE_PATHS.SHORT_TERM_LOAN,
];

export const toggleIntercom = ({
  pathname,
  override,
  isMobile,
}: {
  pathname?: string;
  override?: boolean;
  isMobile: boolean;
}) => {
  const isNative = Capacitor.isNativePlatform();

  if (Capacitor.isNativePlatform() && window?.Intercom) {
    window?.Intercom('shutdown');
  }

  const elIntercomLW = document.getElementsByClassName('intercom-lightweight-app');

  const elIntercom = document.getElementById('intercom-frame');
  const elIntercomApp = document.getElementsByClassName('intercom-app');

  if (elIntercomLW.length == 0 && elIntercom == null && elIntercomApp == null) {
    setTimeout(() => {
      toggleIntercom({ pathname, override, isMobile });
    }, 3000);
  } else {
    let isVisible = true;

    if (pathname) {
      if (isNative) {
        for (let i = 0; i < NATIVE_INTERCOM_DISABLED_PARTIAL_PATHS.length; i += 1) {
          if (pathname.includes(NATIVE_INTERCOM_DISABLED_PARTIAL_PATHS[i])) {
            isVisible = false;
          }
        }

        for (let i = 0; i < NATIVE_INTERCOM_DISABLED_PATHS.length; i += 1) {
          if (pathname == NATIVE_INTERCOM_DISABLED_PATHS[i]) {
            isVisible = false;
          }
        }
      } else if (isMobile) {
        for (let i = 0; i < WEB_INTERCOM_DISABLED_PARTIAL_PATHS.length; i += 1) {
          if (pathname.includes(WEB_INTERCOM_DISABLED_PARTIAL_PATHS[i])) {
            isVisible = false;
          }
        }

        for (let i = 0; i < WEB_INTERCOM_DISABLED_PATHS.length; i += 1) {
          if (pathname == WEB_INTERCOM_DISABLED_PATHS[i]) {
            isVisible = false;
          }
        }
      }
    } else if (isMobile) {
      isVisible = override;
    }

    try {
      if (Capacitor.isNativePlatform()) {
        if (isVisible) {
          Intercom.displayInAppMessages();
          Intercom.displayLauncher();
        } else {
          Intercom.hideInAppMessages();
          Intercom.hideLauncher();
        }
      } else {
        window?.Intercom('hideNotifications', !isVisible);
      }
    } catch (e) {
      if (window?.Intercom && typeof window.Intercom === 'function') {
        window.Intercom('hideNotifications', !isVisible);
      }
    }
  }
};

export const usePageChange = () => {
  const { pathname } = useLocation();
  const { isMobile } = useWindowWidth();

  React.useEffect(() => {
    scrollToTop();

    if (window && window.analytics) {
      window.analytics.page();
    }

    toggleIntercom({ pathname, isMobile });
  }, [pathname]);
};
